import BaseEventPostGrid from "../../vendor/plug-and-play-design/pegasus-one-event-post-grid/src/script";

class EventPostGrid extends BaseEventPostGrid {
    filterPrefix = {
        taxonomy: "filter-t-",
        meta: "filter-m-",
        month: "filter-f",
        search: "",
    };

    yearOpen = new Date().getFullYear();

    showFilters = false;
    lastWidth = null;

    init() {
        super.init();

        pegasus.onResizeFinished(() => {
            this.updateFiltersVisibilityFromWidth({
                requireHorizontalResize: true,
            });
        }, true);
    }

    hasHorizontalResize(width = window.innerWidth) {
        if (this.lastWidth !== null && width === this.lastWidth) {
            return false;
        }

        this.lastWidth = width;
        return true;
    }

    updateFiltersVisibilityFromWidth({
        width = window.innerWidth,
        requireHorizontalResize = false,
    } = {}) {
        if (requireHorizontalResize && !this.hasHorizontalResize(width)) return;
        this.showFilters = width >= 992;
    }

    // Prevent the filters partially matching "aerospace" and "space"

    hasExactTerm(filterValue, term) {
        const terms = String(filterValue)
            .split(",")
            .map((v) => v.trim());

        return terms.includes(String(term).trim());
    }

    filterIsActive(term, filter, type = "taxonomy") {
        const filterName = this.getPrefixedFilter(filter, type);
        return this.hasExactTerm(this.currentFilters[filterName], term);
    }

    toggleFilters(term = "", filterName = "", type = "taxonomy") {
        const filter = this.getPrefixedFilter(filterName, type);

        // If this is the first filter to be added, just add it.
        if (typeof this.currentFilters[filter] === "undefined") {
            this.currentFilters[filter] = term;

            // Refresh the post grid content
            this.fetchContent();
            this.updateFiltersVisibilityFromWidth();
            return;
        }

        // If we have filters for the current filter, check if the term is already in the list.
        if (this.currentFilters[filter].length) {
            if (this.hasExactTerm(this.currentFilters[filter], term)) {
                this.currentFilters[filter] = this.removeFilter(filter, term);
                if (!this.currentFilters[filter].length) {
                    delete this.currentFilters[filter];
                }
            } else {
                this.currentFilters[filter] += "," + term;
            }
        } else {
            // If there isn't a filter for this filter, add it and then add the term to it.
            this.currentFilters[filter] = term;
        }

        // Refresh the post grid content
        if (fetch) {
            this.fetchContent();
            this.updateFiltersVisibilityFromWidth();
        }
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("eventPostGrid", () => new EventPostGrid());
});
